export const chaninId = 999999999;

export const mainAddress = 'eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
